var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-number-field',_vm._g(_vm._b({attrs:{"loader-height":"4","persistent-hint":"","dense":""}},'core-number-field',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }